<template>
  <div class="user_note" :class="{ 'selected': selected }">
    <div class="tag_note_con">
        <div class="ents_tag_title">
            <h5>הוספת הערות ליזמים:</h5>
            <ul class="ents_tag_list">
                <li class="ents_tag_item" v-for="ent in note.ents" :key="ent.id">
                    <span>{{ ent.name }}</span>
                    <div class="close_icon" @click="$emit('removeEnt', ent.id, note.id)">
                        <i class="fas fa-times"></i>
                    </div>
                </li>
            </ul>
        </div>
        <div class="note_actions">
            <textarea v-model="note.text" :disabled="!selected || mode === 'watch'" placeholder="כאן מכניסים את הטקסט "></textarea>
            <div class="actions">
                <div class="btn_b" @click="saveNote" :class="{ 'text_s': selected, 'disabled': mode === 'watch' }" v-text="selected ? 'שמירה' : 'עריכה'"></div>
                <div class="trash_icon" @click="mode === 'edit' && removeNote" :class="{ 'disabled': mode === 'watch' }">
                    <div class="icon"></div>
                </div>
                <div class="add_note" @click="mode === 'edit' && $emit('addNote', note.id)" :class="{ 'disabled': mode === 'watch' }">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M7 1L7 13" stroke="#4AA950" stroke-width="2" stroke-linecap="round"/>
                    <path d="M13 7L1 7" stroke="#4AA950" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        note: {
            type: Object,
            required: true
        },
        selected: {
            type: Boolean,
            default: false
        },
        mode: {
            type: String,
            default: 'edit',
            validator: (value) => ['edit', 'watch'].includes(value)
        }
    },
    data() {
        return {
        }
    },
    methods: {
        async removeNote() {
            const { data: is_removed } = await this.api({ action: "lawyer_note/remove_note", data: {
                id: this.note.id,
                project_token: this.$route.params?.token
            }})
            if(is_removed === true) {
                this.toast('הערה נמחקה בהצלחה', 'success')
                this.$emit('removeNote', this.note.id)
            } else {
                this.toast('שימו לב, ישנה שגיאה במחיקת ההערה', 'error')
            }
        },
        async saveNote() {
            if(this.mode !== 'edit') return;
            if(this.selected) {
                const { data: note_id } = await this.api({ action: "lawyer_note/add_note", data: {
                    ...this.note, 
                    ents_ids: this.note.ents.map(ent => ent.id),
                    project_token: this.$route.params?.token
                }})
                console.log(note_id)
                if(note_id) {
                    if (this.note.id != note_id) this.note.id = note_id;
                    this.toast('הערה נשמרה בהצלחה', 'success')
                }
                else {
                    this.toast('שימו לב, ישנה שגיאה בשמירת ההערה', 'error')
                }
                this.$emit('editSaveNote', note_id)
            } else {
                this.$emit('editSaveNote', this.note.id)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.user_note { max-width: 800px; border-radius: 20px; background: #fff; padding: 20px; position: sticky; right: calc(var(--title_width) + var(--gap));
    &.selected { background: var(--gray); box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1); }
    &:not(.selected) {  border: 0.5px solid #A1BCCA; }
    .tag_note_con { display: flex; flex-direction: column; gap: var(--gap);
        .ents_tag_title { display: flex; gap: var(--gap); 
            h5 { font-size: var(--h5); font-weight: bold; }
            .ents_tag_list { display: flex; gap: var(--gap); flex-wrap: wrap;
                li { padding: 2px 5px; display: flex; gap: var(--gap_small); border-radius: 23px;border: 1px solid #80A3B64F; align-items: center;
                    span { color: var(--text_s); font-size: var(--h6);}
                    .close_icon { position: relative; width: 16px; height: 16px; cursor: pointer; background: var(--light_blue); border-radius: 50%;
                        i, svg {  position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); max-height: 100%; color: #fff; font-size: 12px;}
                    }
                }
            } 
        }
        .note_actions {display: flex; gap: var(--gap_xmid);
            textarea { flex: 1; border: 1px solid #80A3B64F; border-radius: 10px; padding: 10px; 
                font-size: var(--h5);
            }
            .actions { display: flex; align-items: center; gap: var(--gap);
                &>div { cursor: pointer; }
                .trash_icon { width: 30px; height: 30px; background: #D9D9D9; border-radius: 50%; 
                    .icon { background-image: url('@/assets/trash.svg'); background-size: 70%; background-position: center; background-repeat: no-repeat; width: 100%; height: 100%; }
                }
                .add_note { display: flex; align-items: center; justify-content: center; width: 30px; height: 30px; background: #fff; border-radius: 50%; border: 1px solid #E4E4E7;
                    svg { width: 60%; height: 60%; }
                }
            }
        }
    }
}
.disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
  pointer-events: none;
}
</style>